import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTheme, Paper, Typography } from "@material-ui/core";
import t from "../../../languages/pl";

const PaperContainer = styled(Paper)`
    min-height: 30vh;
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${props => props.height}px;
    margin: ${props => props.margin}px;
`;

const ReportPreview = props => {
    const { theme, reportPreview, height } = props;
    return (
        <PaperContainer
            square
            height={height}
            margin={theme.spacing(1)}
        >
            {reportPreview
                ?
                <img src={reportPreview} alt="ReportPreview" />
                :
                <center>
                    <Typography variant="subtitle1">
                        {t.noReportChosen}
                    </Typography>
                </center>
            }
        </PaperContainer>
    );
};

ReportPreview.propTypes = {
    theme: PropTypes.object,
    reportPreview: PropTypes.string,
    height: PropTypes.number
};

export default withTheme(ReportPreview);
